export default "__VITE_ASSET__DhU3KHPl__"